/**
 * PAYMENT TERMS STORE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getPaymentTerms,
    getPaymentTerm,
    printPaymentTerm,
    createPaymentTerms,
    updatePaymentTerms,
    deletePaymentTerms,
} from "Core/configuration/payment_terms/config/api.payment_terms";

const state = {
    page: {},
    form: {},
    payment_terms: [],
    payment_term_options: [],
    selectedPaymentTerm: {
        payment_term_id: null,
        company_id: "",
        payment_term_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        payment_term_details: [],
    },
    payment_terms_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_payment_terms: {
        term_days: {
            name: "term_days",
            rules: "trim|max_length[4]|numeric[0]|required",
            max_len: "4",
            min_len: "",
            default_value: "",
        },
        description: {
            name: "description",
            rules: "trim|required",
            max_len: "16777215",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    payment_terms: (state) => {
        return state.payment_terms;
    },
};

// actions
const actions = {
    async fetchPaymentTerms({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getPaymentTerms({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("setPagePaymentTerms", response.data.page);
                }

                if (body.options) {
                    commit("setPaymentTermOptions", response.data.payment_terms);
                } else {
                    commit("setPaymentTerms", response.data.payment_terms);
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchPaymentTerm({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getPaymentTerm(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("setSelectedPaymentTerm", response.data.payment_term);
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printPaymentTerm({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printPaymentTerm(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async savePaymentTerm({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["payment_term_id"] === "undefined" || body["payment_term_id"] == null || body["payment_term_id"] == "") {
                delete body["payment_term_id"];
                response = await createPaymentTerms({ body: body, headers: config.headers });
            } else {
                let payment_term_id = body["payment_term_id"];
                delete body["payment_term_id"];
                response = await updatePaymentTerms({ body: body, headers: config.headers }, payment_term_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deletePaymentTerm({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deletePaymentTerms(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    setPagePaymentTerms(state, page) {
        state.page = page;
    },
    setPaymentTerms(state, payment_terms) {
        state.payment_terms = payment_terms;
    },
    setPaymentTermOptions(state, payment_terms) {
        state.payment_term_options = payment_terms;
    },
    setSelectedPaymentTerm(state, payment_term) {
        state.selectedPaymentTerm = payment_term;
    },
    resetSelectedPaymentTerm(state) {
        for (const key in state.selectedPaymentTerm) {
            if (key in state.rules_payment_terms) {
                state.selectedPaymentTerm[key] = state.rules_payment_terms[key].default_value == "null" ? null : state.rules_payment_terms[key].default_value;
            }
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
